import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StepsNavigationMapService } from '../../services/steps-navigation.service';
import { IndicatorsService } from '../../services/indicators.service';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { PlannerDayStateService } from '../../../planner/services';
import { RouteDataService } from '../../services/route-data.service';
import { IndicationComponent } from "../indication/indication.component";
import { Point, Transfers } from 'src/app/pages/custom-route/interfaces/custom-route.interface';

@Component({
    selector: 'map-indication-card',
    standalone: true,
    imports: [
        CommonModule,
        IndicationComponent,
        TranslateModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './indication-card.component.html',
    styleUrl: './indication-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MapIndicationCardComponent {
    private _routeDataService: RouteDataService = inject(RouteDataService);
    private _indicatorService: IndicatorsService = inject(IndicatorsService);
    private _plannerDayStateService: PlannerDayStateService = inject(PlannerDayStateService);
    private _indicatorsService: IndicatorsService = inject(IndicatorsService);
    private _breakpointsService: BreakpointsService = inject(BreakpointsService);

    public routeSegments = computed<Point[]>(() => this._routeDataService.getRouteSegments()?.[this._plannerDayStateService.dayToShowIndex()]);
    public currentTrameIndex = computed<number>(() => this._routeDataService.getCurrentTrameIndex());
    public currentStepIndex = computed<number>(() => this._routeDataService.getCurrentStepIndex());
    public isMobile = computed<boolean>(() => this._breakpointsService.isMobile());
    public showToggleGPSButton = computed<boolean>(() => this._routeDataService.isToday() && !this._routeDataService.isGeolocationActive() && this.isMobile() && this.stepProgress() < 100)
    public isButtomSheetOpen = computed<boolean>(() => this._indicatorsService.bottomSheetRef() && this.isMobile());

    public transfers = computed<Transfers[]>(() => this.routeSegments()?.[this.currentTrameIndex()]?.transfers)
    public intructions = computed<string>(() => this._indicatorService.getInstructions());
    public sign = computed<string>(() => this._indicatorService.getSign());
    public nextItem = computed<string>(() => this._indicatorService.getNextItem());
    public timeRemaining = computed<number>(() => this._indicatorService.getTimeRemaining());
    public stepProgress = computed<number>(() =>  this._indicatorService.getStepProgress() ?? 0);
    
    public isEnd = computed<boolean>(() => {
        const length: number = this.routeSegments()?.[this.currentStepIndex()]?.transfers?.length;
        const currentStepIndex: number = this.currentStepIndex()
        return length === currentStepIndex
    });  

    public getPercent = computed<number>(() => {
        const totalLength: number = this.routeSegments()?.[this.currentTrameIndex()]?.transfers?.length - 1;
        const currentStepIndex: number = this.currentStepIndex();
        const result = Math.round((currentStepIndex / totalLength) * 100);
        return result;
    });

    public handleIndicationCardClick(): void {
        if (this.isMobile()) 
            this._indicatorsService.openBottomSheetTransfersMobile(this.transfers());
        else 
            this._indicatorsService.openBottomSheetTransfersDesktop(this.transfers());
    }

    public toggleGPS(event: Event): void {
        event.stopPropagation();
        this._routeDataService.enableGeolocation();
    }

}